import { ToggleButton } from '@strata/react-buttons';
import { StatusIcon } from '@strata/react-status-icons';
import { type ComponentProps } from 'react';

interface RuleToggleButtonProps {
    ruleId: string;
    label: string;
    helperText?: string;
    isOn: boolean;
    disabled: boolean;
    onChange: ComponentProps<typeof ToggleButton>['onChange'];
    dateRangeValid: boolean;
}

export const RuleToggleButton = ({
    ruleId,
    label,
    helperText = undefined,
    isOn,
    disabled,
    onChange,
    dateRangeValid,
}: RuleToggleButtonProps) => (
    <ToggleButton
        labelClassName="sds_automations__rule-label"
        label={label}
        id={`rule-${ruleId}-toggle-button`}
        helperText={
            <div className="flex__gap--x-small" style={{ alignItems: 'center' }}>
                {!dateRangeValid && (
                    <div className="sds_automations__toggle-warning">
                        <StatusIcon
                            status={StatusIcon.Statuses.WARNING}
                            tooltipText={
                                <>
                                    <div>Rule is not Running.</div>
                                    <div>Start and/or end dates are out of range.</div>
                                </>
                            }
                        />
                        (Not Running)
                    </div>
                )}
                {helperText}
            </div>
        }
        isOn={isOn}
        disabled={disabled}
        onChange={onChange}
        // Do not change active rule when clicking toggle
        onClick={(e) => e.stopPropagation()}
    />
);
